import { render, staticRenderFns } from "./Grupo.vue?vue&type=template&id=126eb8f0&scoped=true&"
import script from "./Grupo.vue?vue&type=script&lang=js&"
export * from "./Grupo.vue?vue&type=script&lang=js&"
import style0 from "./Grupo.vue?vue&type=style&index=0&id=126eb8f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126eb8f0",
  null
  
)

export default component.exports